var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "OverlayButton",
    {
      attrs: { disabled: _vm.isDisabled },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm.isLoading
        ? [
            _c("VsIcon", { attrs: { icon: "md:sync" } }),
            _vm._v(" "),
            _c("span", { staticClass: "align-middle" }, [_vm._t("loading")], 2)
          ]
        : _vm.error
        ? [
            _c("VsIcon", { attrs: { icon: "md:error_outline" } }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "align-middle" },
              [_vm._t("error", [_vm._v(_vm._s(_vm.error.message))])],
              2
            )
          ]
        : _c("span", [_vm._t("default")], 2)
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }